export { default as Collapse } from '@material-ui/core/Collapse'
export * from './CollapseWithHeader'
